/**
 * assets/js/frontend/breakpoint-observer.js
 * 
 * @author jjarolim
 */

import { getBreakpoint, watchBreakpoint } from './breakpoint.js'

const init = () => {

    // Set initial breakpoint class

    const initial_breakpoint = getBreakpoint();
    document.body.classList.add( 'is-breakpoint-' + initial_breakpoint.name )

    // Constantly watch and update breakpoint class

    watchBreakpoint(({ from, to }) => {
        document.body.classList.remove( 'is-breakpoint-' + from.name )
        document.body.classList.add( 'is-breakpoint-' + to.name )
    });

}

export { init }